export function nextRoundTime(ts) {
    const dateNow = new Date(ts);

    const now = Date.parse(
        new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate(), dateNow.getHours(), dateNow.getMinutes(), 0, 0)
    );

    return new Date(now + ( (5 - dateNow.getMinutes() % 5) + 5 ) * 60 * 1000);
}
